<mojo-navbar></mojo-navbar>
<div class="wrapper">
  <div>
    <h2>
      You do not appear to be licensed for this product.
      <br/>
      Please contact your system administrator.
    </h2>
  </div>
</div>
